import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import TimePicker from 'react-time-picker';
import PN from "persian-number";
import DeleteModal from '../Delete/Delete.js'
import Drp_Bank from '../Bank/Drp_Bank.js';
import Drp_POS from '../Bank/Drp_POS.js';
import Drp_Fund from '../Fund/Drp_Fund.js';


const InsertRecieptIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const POSRef = useRef();
    const BankRef = useRef();
    const FundRef = useRef();
    const CheckFundRef = useRef();
    const DeleteRef = useRef();
    let navigate = useNavigate();


    const [RefId, setRefId] = useState(localStorage.getItem("FactorHeaderId"));
    const [FiscalYearId, setFiscalYearId] = useState(-1);
    const [Code, setCode] = useState("");
    const [RecieptList, setRecieptList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty());

        ///  1 Fund 
        ///  2 POS
        ///  3 Havale
        ///  4 check
        ///  6 AccountTransfer
        ///  7 Online
        
    const [TotalFundReciept, setTotalFundReciept] = useState(0);
    const [TotalPOSReciept, setTotalPOSReciept] = useState(0);
    const [TotalHavaleReciept, setTotalHavaleReciept] = useState(0);
    const [TotalcheckReciept, setTotalcheckReciept] = useState(0);
    const [PayType, setPayType] = useState(2);
    const [HeaderPrice, setHeaderPrice] = useState(0);
    const [RemainPrice, setRemainPrice] = useState(0);
    const [TotalReciept, setTotalReciept] = useState(0);
    const [CustomerId, setCustomerId] = useState(General.GuidEmpty());
    const [Customer, setCustomer] = useState("");
    const [RegisterDate, setRegisterDate] = useState("");
    const [Mobile, setMobile] = useState("");
    const [FinancialBalance, setFinancialBalance] = useState("");
    const [hasFactor, sethasFactor] = useState(0);
    const [PayDate, setPayDate] = useState(moment(new Date()));

    //#endregion



    //#region Methods

    const PayDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setPayDate(moment(m, 'jYYYY/jMM/jDD'));
    }
    const GetById = (headerId) => {
        trackPromise(
            fetch(General.ApiRoute() + '/Factor/GetHeaderById', {
                method: 'Post',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': headerId
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    setHeaderPrice(result.totalPrice);
                    setMobile(result.mobile);
                    setRegisterDate(result.registerDate);
                    setCustomer(result.customer);
                    setCustomerId(result.customerId);
                    setTotalReciept(result.totalReciept);
                    setRemainPrice(result.totalPrice - result.totalReciept);
                    setCode(result.code);
                    setFiscalYearId(result.fiscalYearId);
                    setFinancialBalance(result.financialBalance)
                    // BindReciept(result.totalPrice);
                })
        )
    }

    const BindReciept = (totalPrice) => {
        var tmp = [];
        var remainPrice = totalPrice;

        trackPromise(
            fetch(General.ApiRoute() + '/RecieptReceived/GetByRefId', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'RefId': localStorage.getItem("FactorHeaderId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    var totalFundReciept = 0;
                    var totalPOSReciept = 0;
                    var totalKartReciept = 0;
                    var totalHavaleReciept = 0;
                    var totalcheckReciept = 0;




                    for (var i = 0; i < result.length; i++) {
                        remainPrice = remainPrice - result[i].price;
                        totalFundReciept = result[i].payType == 1 ? totalFundReciept + result[i].price : totalFundReciept;
                        totalPOSReciept = result[i].payType == 2 ? totalPOSReciept + result[i].price : totalPOSReciept;
                        totalHavaleReciept = result[i].payType == 3 ? totalHavaleReciept + result[i].price : totalHavaleReciept;
                        totalcheckReciept = result[i].payType == 4 ? totalcheckReciept + result[i].price : totalcheckReciept;
                        tmp.push({
                            row: i + 1,
                            Id: result[i].id,
                            status: "",
                            Price: result[i].price,
                            PayType: result[i].payType,
                            PayDate: result[i].payDate == null ? "" : result[i].payDate,
                            PayTime: result[i].payTime,
                            RecieptNo: result[i].recieptNo,
                            CheckNo: result[i].checkNo,
                            CheckDate: result[i].checkDate == null ? "" : result[i].checkDate,
                            Branch: result[i].branch,
                            SourceAccountNo: result[i].sourceAccountNo,
                            Bank: result[i].bank,
                            Comment: result[i].comment,
                            POSId: result[i].posId,
                            POS: result[i].pos,
                            BankAccountId: result[i].bankAccountId,
                            BankAccount: result[i].bankAccount,
                            FundId: result[i].fundId,
                            Fund: result[i].fund,
                            ConfirmCheck: result[i].confirmCheck,

                        })
                    }


                    tmp.push(
                        {
                            row: tmp.length + 1,
                            Id: General.GuidEmpty(),
                            status: "EDIT",
                            Price: RemainPrice > 0 ? PN.sliceNumber(RemainPrice) : 0,
                            PayType: PayType,
                            PayDate: moment(new Date()),
                            PayTime: new Date(),
                            RecieptNo: "",
                            CheckNo: "",
                            SourceAccountNo: "",
                            CheckDate: moment(new Date()),
                            Branch: "",
                            Bank: "",
                            Comment: "",
                            POSId: General.GuidEmpty(),
                            POS: "",
                            BankAccountId: General.GuidEmpty(),
                            BankAccount: "",
                            FundId: General.GuidEmpty(),
                            Fund: "",
                            ConfirmCheck: 0,
                        });
                    setRecieptList(tmp)
                    setTotalReciept(totalPrice - remainPrice);
                    setRemainPrice(remainPrice);
                    setTotalFundReciept(totalFundReciept);
                    setTotalHavaleReciept(totalHavaleReciept);
                    setTotalPOSReciept(totalPOSReciept);
                    setTotalcheckReciept(totalcheckReciept);

                    setTimeout(() => {

                        if (PayType == 1) {
                            FundRef.current.Bind(General.GuidEmpty());
                        }
                        if (PayType == 2) {
                            POSRef.current.Bind(General.GuidEmpty());
                        }
                        if (PayType == 3) {
                            BankRef.current.Bind(General.GuidEmpty());
                        }
                        if (PayType == 4) {
                            CheckFundRef.current.Bind(General.GuidEmpty());
                        }


                        const firstInput = document.querySelector(
                            'input:not([disabled]), textarea, select'
                        );

                        firstInput?.focus();

                    }, 500)


                })

        )

    }


    const AddItem = (row) => {

        var temp = [...RecieptList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {

            if (temp[index].PayDate == "" || temp[index].PayDate == null) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ دریافت اجباری می باشد")), 'topCenter')
                return;
            }
            // if (temp[index].PayTime == "" || temp[index].PayTime == null) {
            //     toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن ساعت دریافت اجباری می باشد")), 'topCenter')
            //     return;
            // }
            if (temp[index].Price == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن مبلغ اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].FundId == General.GuidEmpty() && (temp[index].PayType == 1 || temp[index].PayType == 4)) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن صندوق اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].POSId == General.GuidEmpty() && temp[index].PayType == 2) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن POS اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].BankAccountId == General.GuidEmpty() && (temp[index].PayType == 3)) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن بانک اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].CheckNo == "" && temp[index].PayType == 4) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن شماره چک اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].Bank == "" && temp[index].PayType == 4) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن بانک چک اجباری می باشد")), 'topCenter')
                return;
            }
            if (temp[index].ConfirmCheck == -1 && temp[index].PayType == 4) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن وضعیت چک اجباری می باشد")), 'topCenter')
                return;
            }
            if ((temp[index].CheckDate == "" || temp[index].CheckDate == null) && temp[index].PayType == 4) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ سررسید چک اجباری می باشد")), 'topCenter')
                return;
            }

            temp[index].status = "";
            temp[index].Price = temp[index].Price != "0" && temp[index].Price != 0 ? temp[index].Price.replaceAll(',', '') * 1 : 0;
            temp[index].PayTime = temp[index].PayTime.getHours() + ":" + temp[index].PayTime.getMinutes();
            temp[index].CheckDate = PayType == 4 ? moment(temp[index].CheckDate.format()).format('jYYYY/jMM/jDD') : "";
            temp[index].PayDate = moment(temp[index].PayDate.format()).format('jYYYY/jMM/jDD');

            setTotalFundReciept(temp.filter(x => x.PayType == 1 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));

            setTotalPOSReciept(temp.filter(x => x.PayType == 2 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));

            setTotalHavaleReciept(temp.filter(x => x.PayType == 3 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));

            // setTotalPersonalcheckPayment(temp.filter(x => x.PayType == 4).map(o => o.Price).reduce((a, b) => a + b, 0));

            setTotalcheckReciept(temp.filter(x => x.PayType == 4 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));

            // setTotalAccountTransferPayment(temp.filter(x => x.PayType == 7).map(o => o.Price).reduce((a, b) => a + b, 0));

            setTotalReciept(temp.filter(x => x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));

            setRemainPrice(HeaderPrice * 1 - temp.filter(x => x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));





            setRecieptList(temp);
            console.dir(temp)
            console.dir(temp.filter(item => item.FundId == General.GuidEmpty()).length == 0)
            if (
                //(PayType == 7 && temp.filter(item => item.AccountTransferId == General.GuidEmpty() && item.PayType == 7).length == 0) ||
                (PayType == 1 && temp.filter(item => item.FundId == General.GuidEmpty() && item.PayType == 1).length == 0) ||
                (PayType == 2 && temp.filter(item => item.POSId == General.GuidEmpty() && item.PayType == 2).length == 0) ||
                (PayType == 3 && temp.filter(item => item.BankAccountId == General.GuidEmpty() && item.PayType == 3).length == 0) ||
                (PayType == 4 && temp.filter(item => item.FundId == General.GuidEmpty() && item.PayType == 4).length == 0)
                //||
                //(PayType == 6 && temp.filter(item => item.RecieptItemId == General.GuidEmpty() && item.PayType == 6).length == 0) 
            )
                NewItem(PayType, HeaderPrice - temp.filter(x => x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0))

        }


    }



    const onEditItem = (row) => {
        var temp = [...RecieptList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].status = "EDIT";
            temp[index].Price = PN.sliceNumber(temp[index].Price);
            temp[index].PayDate = moment(temp[index].PayDate, 'jYYYY/jMM/jDD');
            // temp[index].PayTime = convertHHMMToDate(temp[index].PayTime);
            temp[index].CheckDate = moment(temp[index].CheckDate, 'jYYYY/jMM/jDD');
        }
        setRecieptList(temp);
    }

    const NewItem = (payType, remainPrice = -1) => {

        setPayType(payType)
        var temp = [...RecieptList];
        var index = temp.findIndex(x => x.status == "EDIT" && x.PayType == payType);
        if (index == -1) {
            temp.push(
                {
                    row: RecieptList.length + 1,
                    Id: General.GuidEmpty(),
                    RefId: RefId,
                    Editable: true,
                    status: "EDIT",
                    Price: remainPrice == -1 && RemainPrice > 0 ? PN.sliceNumber(RemainPrice) : remainPrice > 0 ? PN.sliceNumber(remainPrice) : 0,
                    PayType: payType,
                    PayDate: moment(new Date()),
                    PayTime: new Date(),
                    RecieptNo: "",
                    CheckNo: "",
                    CheckDate: moment(new Date()),
                    Branch: "",
                    Bank: "",
                    Comment: "",
                    POSId: General.GuidEmpty(),
                    POS: "",
                    // BuyPrice: 0,
                    BankAccountId: General.GuidEmpty(),
                    BankAccount: "",
                    FundId: General.GuidEmpty(),
                    Fund: "",
                    ConfirmCheck: 0,
                });
            setRecieptList(temp)
        }

        setTimeout(() => {
            if (payType == 2) {
                POSRef.current.Bind(General.GuidEmpty());
            }
            if (payType == 3) {
                BankRef.current.Bind(General.GuidEmpty());
            }
            if (payType == 1) {
                FundRef.current.Bind(General.GuidEmpty());
            }
            if (payType == 4) {
                CheckFundRef.current.Bind(General.GuidEmpty());
            }

        }, 500)
    }


    const convertHHMMToDate = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date;
    };

    const Change_Item = (row, dataType, value, text) => {


        var temp = [...RecieptList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            if (dataType == "Price") {
                var price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                temp[index].Price = PN.sliceNumber(price);
            }
            else if (dataType == "RecieptNo") {
                temp[index].RecieptNo = value;
            }
            else if (dataType == "CheckNo") {
                temp[index].CheckNo = value;
            }
            else if (dataType == "Branch") {
                temp[index].Branch = value;
            }
            else if (dataType == "Bank") {
                temp[index].Bank = value;
            }
            else if (dataType == "Comment") {
                temp[index].Comment = value;
            }
            else if (dataType == "SourceAccountNo") {
                temp[index].SourceAccountNo = value;
            }
            else if (dataType == "POS") {
                temp[index].POSId = value;
                temp[index].POS = text;
            }
            else if (dataType == "BankAccount") {
                temp[index].BankAccountId = value;
                temp[index].BankAccount = text;
            }
            else if (dataType == "Fund") {
                temp[index].FundId = value;
                temp[index].Fund = text;
            }
            else if (dataType == "ConfirmCheck") {
                temp[index].ConfirmCheck = value;
            }

            else if (dataType == "PayTime") {
                temp[index].PayTime = value;
            }
            else if (dataType == "CheckDate") {
                var m = moment(value.format()).format('jYYYY/jMM/jDD');
                temp[index].CheckDate = moment(m, 'jYYYY/jMM/jDD');
            }
            else if (dataType == "PayDate") {
                var m = moment(value.format()).format('jYYYY/jMM/jDD');
                temp[index].PayDate = moment(m, 'jYYYY/jMM/jDD');
            }
            console.dir(temp[index])
            console.dir(temp)

            setRecieptList(temp);
        }
    }


    const Delete = (row) => {
        var temp = [...RecieptList.filter(item => item.row !== row)];
        setRecieptList(temp);
        setTotalFundReciept(temp.filter(x => x.PayType == 1 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalPOSReciept(temp.filter(x => x.PayType == 2 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalHavaleReciept(temp.filter(x => x.PayType == 3 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));
        // setTotalPersonalcheckPayment(temp.filter(x => x.PayType == 4).map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalcheckReciept(temp.filter(x => x.PayType == 4 && x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));
        // setTotalAccountTransferPayment(temp.filter(x => x.PayType == 7).map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalReciept(temp.filter(x => x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));
        setRemainPrice(HeaderPrice * 1 - temp.filter(x => x.status != "EDIT").map(o => o.Price).reduce((a, b) => a + b, 0));

        const inputElement = document.querySelector('.FocusBtn');
        if (inputElement) {
            inputElement.focus();
        }
    }


    const Save = (IsPrint) => {

        var children = [...RecieptList.filter(item => item.status == "" || item.Editable == " ")];

        console.dir(children)
        if (PayDate == "" || PayDate == null) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ دریافت اجباری می باشد")), 'topCenter')
            return;
        }

        else if (children.length == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن آیتم های دریافت اجباری می باشد")), 'topCenter')
            return;
        }
        // else if (Acc_CId == General.GuidEmpty()) {
        // toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب معین اجباری می باشد")), 'topCenter')
        // return;
        // }

        // else if (Sub_Acc_Id1 == General.GuidEmpty() && Sub_Acc_L1 != -1) {
        // toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب تفصیلی سطح 1 اجباری می باشد")), 'topCenter')
        // return;
        // }
        // else if (Sub_Acc_Id2 == General.GuidEmpty() && Sub_Acc_L2 != -1) {
        // toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب تفصیلی سطح 2 اجباری می باشد")), 'topCenter')
        // return;
        // }
        // else if (Sub_Acc_Id3 == General.GuidEmpty() && Sub_Acc_L3 != -1) {
        // toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب تفصیلی سطح 3 اجباری می باشد")), 'topCenter')
        // return;
        // }
        else {
            var RequestOptions = {
                data: {
                    "PayDate": moment(PayDate.format()).format('jYYYY/jMM/jDD'),
                    "Id": Id == null ? General.GuidEmpty() : Id,
                    // "Acc_CId": Acc_CId,
                    // "DOCSettingId": DOCSettingId,
                    // "Acc_CTitle": Acc_CTitle,
                    // "Sub_Acc_Id1": Sub_Acc_Id1,
                    // "Sub_Acc_Id2": Sub_Acc_Id2,
                    // "Sub_Acc_Id3": Sub_Acc_Id3,
                    // "Sub_Acc_L1": Sub_Acc_L1,
                    // "Sub_Acc_L2": Sub_Acc_L2,
                    // "Sub_Acc_L3": Sub_Acc_L3,
                    "Comment": Comment,
                    "FiscalYearId": FiscalYearId,
                    "Children": children,
                    "Ref": [
                        {
                            refId: RefId,
                            price: TotalReciept
                        }
                    ]

                },
                url: General.ApiRoute() + "/RecieptReceived/InsertFromFactor",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }

            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {

                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                            // BindPayment(HeaderPrice, headerId);
                            if (IsPrint)
                                window.open("/Printfactor", "_blank");
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }

                    }).catch((error) => {
                        console.dir(error)
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        }
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 21);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");

                    }
                    else {
                        if (localStorage.getItem("FactorHeaderId") != undefined && localStorage.getItem("FactorHeaderId") != General.GuidEmpty()) {
                            GetById(localStorage.getItem("FactorHeaderId"));
                        }


                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const handelKeyDown = (e) => {
        if (e.key == "Enter") {

            if ([...RecieptList].length > 0) {
                var index = [...RecieptList].findIndex(x => x.status == "EDIT" && x.PayType == PayType);
                if (index != -1) {
                    AddItem([...RecieptList][index].row);
                    return;
                }
                else {
                    NewItem(PayType);
                    return;

                }
            }
            else {
                NewItem();
            }
        }
        if (e.key == "Delete") {
            var index = [...RecieptList].findIndex(x => x.status == "EDIT" && x.PayType == PayType);

            if (index != -1)
                Delete([...RecieptList][index].row);
            else if ([...RecieptList].length > 0) {
                var LastPay = [...RecieptList].filter(x => x.PayType == PayType).length;
                if (LastPay != 0)
                    Delete([...RecieptList][LastPay - 1].row);
            }
        }


        if (e.key == "Escape") {
            Back()
        }


        if (e.shiftKey && e.code === 'KeyP' && e.code === 'KeyS') {
            // window.open("/Printfactor", "_blank");
            Save(1);
        }
        if (e.shiftKey && e.code === 'KeyS') {
            // window.open("/Printfactor", "_blank");
            Save(0)
        }

    }
    const Back = () => {
        if (localStorage.getItem("BackPage") == null)
            navigate("/InsertFactor")
        else {
            navigate("/" + localStorage.getItem("BackPage"))
            localStorage.removeItem("BackPage")
            localStorage.getItem("FactorHeaderId")
        }
    }


    useEffect(() => {
        CheckPermission();
        // POSIsDefaultRef.current.GetIsDefault();
        document.title = " دریافت ";

    }, [])
    //#endregion



    return (

        <Layout title="ثبت دریافت">
            <div className="h-100 p-1" onKeyDown={handelKeyDown} >
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Save(0)}> ذخیره </rsuite.Button>
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Save(1)}> ذخیره و پرینت</rsuite.Button>
                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => Back()}>  بازگشت</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>

                        <rsuite.Col xxl={24}>
                            <label> تاریخ دریافت </label>
                            <DatePicker className="rs-input " isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={PayDate} onChange={PayDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className='mt-2'>
                            <label>شماره فاکتور : </label> {Code}
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className='mt-2'>
                            <label>شماره همراه مشتری : </label> {Mobile}
                        </rsuite.Col>
                        <rsuite.Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={24} className='mt-2'>
                            <label> نام و نام خانوادگی : </label> {Customer}
                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1 mb-5 pb-5" >
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Button className='FocusBtn' appearance="primary" color="green" size='xs'
                                onClick={() => NewItem(PayType)}>
                                اضافه شدن دریافت جدید
                            </rsuite.Button>
                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-3'>
                            <rsuite.Tabs defaultActiveKey={PayType.toString()} onSelect={(eventKey) => (setPayType(eventKey), NewItem(eventKey))} appearance="subtle">
                                <rsuite.Tabs.Tab eventKey="2" title="کارت خوان">
                                    <rsuite.Table height={RecieptList.filter(o => o.PayType == 2).length < 3 ? 160 : RecieptList.filter(o => o.PayType == 2).length >= 3 && RecieptList.filter(o => o.PayType == 2).length < 6 ? RecieptList.filter(o => o.PayType == 2).length * 70 : 320}
                                        data={RecieptList.filter(o => o.PayType == 2)} wordWrap>

                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell>تاریخ  </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <DatePicker className="rs-input " isGregorian={false}
                                                                timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayDate", value, "");
                                                                }} />
                                                        ) : (
                                                            <text>
                                                                {rowData.PayDate}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>
                                        {/* <rsuite.Table.Column flexGrow={1}  resizable>
                                            <rsuite.Table.HeaderCell>ساعت  </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (



                                                            <rsuite.TimePicker block onChange={value => {
                                                                Change_Item?.(rowData.row, "PayTime", value, "");
                                                            }} value={rowData.PayTime} />

                                                        ) : (
                                                            <text>
                                                                {rowData.PayTime}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>


                                        </rsuite.Table.Column> */}
                                        <rsuite.Table.Column flexGrow={2} resizable>
                                            <rsuite.Table.HeaderCell>POS </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (


                                                            <Drp_POS value={rowData.POSId} onChange={(value, text) => {
                                                                Change_Item?.(rowData.row, "POS", value, text);
                                                            }} ref={POSRef} />


                                                        ) : (
                                                            <text>
                                                                {rowData.POS}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>شماره رسید</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.RecieptNo} onChange={value => {
                                                                    Change_Item?.(rowData.row, "RecieptNo", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.RecieptNo}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (

                                                            <rsuite.Input value={rowData.Price} onChange={value => {
                                                                Change_Item?.(rowData.row, "Price", value, "");
                                                            }}

                                                            />

                                                        ) : (
                                                            <text>
                                                                {PN.sliceNumber(rowData.Price)}
                                                                <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={3} >
                                            <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Comment", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.Comment}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column width={100} fixed='right'>
                                            <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>


                                                        {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                            :
                                                            <BiIcon.BiSave onClick={() => AddItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <BiIcon.BiTrash onClick={() => Delete(rowData.row)} className='fs-6 text-danger Cursor' />
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                    </rsuite.Table>
                                    <rsuite.Row>
                                        <rsuite.Col xs={24} className='fw-bold text-start'>
                                            {RecieptList.filter(o => o.PayType == 2 && o.status == "EDIT").length > 0 && RecieptList.filter(o => o.PayType == 2 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(RecieptList.filter(o => o.PayType == 2 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                        </rsuite.Col>
                                    </rsuite.Row>
                                </rsuite.Tabs.Tab>
                                <rsuite.Tabs.Tab eventKey="3" title="واریز به حساب">
                                    <rsuite.Table height={RecieptList.filter(o => o.PayType == 3).length < 3 ? 160 : RecieptList.filter(o => o.PayType == 3).length >= 3 && RecieptList.filter(o => o.PayType == 3).length < 6 ? RecieptList.filter(o => o.PayType == 3).length * 70 : 320}
                                        data={RecieptList.filter(o => o.PayType == 3)} wordWrap>

                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell>تاریخ  </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <DatePicker className="rs-input " isGregorian={false}
                                                                timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayDate", value, "");
                                                                }} />
                                                        ) : (
                                                            <text>
                                                                {rowData.PayDate}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>
                                        {/* <rsuite.Table.Column flexGrow={1}  resizable>
                                            <rsuite.Table.HeaderCell>ساعت </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (



                                                            <rsuite.TimePicker block onChange={value => {
                                                                Change_Item?.(rowData.row, "PayTime", value, "");
                                                            }} value={rowData.PayTime} />

                                                        ) : (
                                                            <text>
                                                                {rowData.PayTime}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>


                                        </rsuite.Table.Column> */}
                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>شماره حساب مبدا</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.SourceAccountNo} onChange={value => {
                                                                    Change_Item?.(rowData.row, "SourceAccountNo", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.SourceAccountNo}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={2} resizable>
                                            <rsuite.Table.HeaderCell>شماره حساب مقصد </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (


                                                            <Drp_Bank value={rowData.BankAccountId} onChange={(value, text) => {
                                                                Change_Item?.(rowData.row, "BankAccount", value, text);
                                                            }} ref={BankRef} />


                                                        ) : (
                                                            <text>
                                                                {rowData.BankAccount}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>شماره رسید</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.RecieptNo} onChange={value => {
                                                                    Change_Item?.(rowData.row, "RecieptNo", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.RecieptNo}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <rsuite.Input value={rowData.Price} onChange={value => {
                                                                Change_Item?.(rowData.row, "Price", value, "");
                                                            }}

                                                            />

                                                        ) : (
                                                            <text>
                                                                {PN.sliceNumber(rowData.Price)}
                                                                <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={3} >
                                            <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Comment", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.Comment}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column width={100} fixed='right'>
                                            <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>


                                                        {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                            :
                                                            <BiIcon.BiSave onClick={() => AddItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <BiIcon.BiTrash onClick={() => Delete(rowData.row)} className='fs-6 text-danger Cursor' />
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                    </rsuite.Table>
                                    <rsuite.Row>
                                        <rsuite.Col xs={24} className='fw-bold text-start'>
                                            {RecieptList.filter(o => o.PayType == 3 && o.status == "EDIT").length > 0 && RecieptList.filter(o => o.PayType == 3 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(RecieptList.filter(o => o.PayType == 3 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                        </rsuite.Col>
                                    </rsuite.Row>
                                </rsuite.Tabs.Tab>

                                <rsuite.Tabs.Tab eventKey="1" title="نقدی">
                                    <rsuite.Table height={RecieptList.filter(o => o.PayType == 1).length < 3 ? 160 : RecieptList.filter(o => o.PayType == 1).length >= 3 && RecieptList.filter(o => o.PayType == 1).length < 6 ? RecieptList.filter(o => o.PayType == 1).length * 70 : 320}
                                        data={RecieptList.filter(o => o.PayType == 1)} wordWrap>

                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell>تاریخ  </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <DatePicker className="rs-input " isGregorian={false}
                                                                timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayDate", value, "");
                                                                }} />
                                                        ) : (
                                                            <text>
                                                                {rowData.PayDate}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>
                                        {/* <rsuite.Table.Column flexGrow={1}  resizable>
                                            <rsuite.Table.HeaderCell>ساعت  </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (



                                                            <rsuite.TimePicker block onChange={value => {
                                                                Change_Item?.(rowData.row, "PayTime", value, "");
                                                            }} value={rowData.PayTime} />

                                                        ) : (
                                                            <text>
                                                                {rowData.PayTime}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>


                                        </rsuite.Table.Column> */}
                                        <rsuite.Table.Column flexGrow={2} resizable>
                                            <rsuite.Table.HeaderCell> صندوق </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (


                                                            <Drp_Fund value={rowData.FundId} onChange={(value, text) => {
                                                                Change_Item?.(rowData.row, "Fund", value, text);
                                                            }} ref={FundRef} />


                                                        ) : (
                                                            <text>
                                                                {rowData.Fund}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>


                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <rsuite.Input value={rowData.Price} onChange={value => {
                                                                Change_Item?.(rowData.row, "Price", value, "");
                                                            }}

                                                            />

                                                        ) : (
                                                            <text>
                                                                {PN.sliceNumber(rowData.Price)}
                                                                <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={3} >
                                            <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Comment", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.Comment}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column width={100} fixed='right'>
                                            <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>


                                                        {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                            :
                                                            <BiIcon.BiSave onClick={() => AddItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <BiIcon.BiTrash onClick={() => Delete(rowData.row)} className='fs-6 text-danger Cursor' />
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                    </rsuite.Table>
                                    <rsuite.Row>
                                        <rsuite.Col xs={24} className='fw-bold text-start'>
                                            {RecieptList.filter(o => o.PayType == 1 && o.status == "EDIT").length > 0 && RecieptList.filter(o => o.PayType == 1 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(RecieptList.filter(o => o.PayType == 1 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                        </rsuite.Col>
                                    </rsuite.Row>
                                </rsuite.Tabs.Tab>
                                <rsuite.Tabs.Tab eventKey="4" title="چک">
                                    <rsuite.Table height={RecieptList.filter(o => o.PayType == 4).length < 3 ? 160 : RecieptList.filter(o => o.PayType == 4).length >= 3 && RecieptList.filter(o => o.PayType == 4).length < 6 ? RecieptList.filter(o => o.PayType == 4).length * 70 : 320}
                                        data={RecieptList.filter(o => o.PayType == 4)} wordWrap>

                                        <rsuite.Table.Column flexGrow={1} resizable>
                                            <rsuite.Table.HeaderCell>تاریخ ثبت </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <DatePicker className="rs-input " isGregorian={false}
                                                                timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayDate", value, "");
                                                                }} />
                                                        ) : (
                                                            <text>
                                                                {rowData.PayDate}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>
                                        {/* <rsuite.Table.Column flexGrow={1}  resizable>
                                            <rsuite.Table.HeaderCell>ساعت ثبت </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (



                                                            <rsuite.TimePicker block onChange={value => {
                                                                Change_Item?.(rowData.row, "PayTime", value, "");
                                                            }} value={rowData.PayTime} />

                                                        ) : (
                                                            <text>
                                                                {rowData.PayTime}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>


                                        </rsuite.Table.Column> */}
                                        <rsuite.Table.Column flexGrow={2} resizable>
                                            <rsuite.Table.HeaderCell> صندوق </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >

                                                {(rowData, rowIndex) => {
                                                    return <>

                                                        {rowData.status == 'EDIT' ? (


                                                            <Drp_Fund value={rowData.FundId} onChange={(value, text) => {
                                                                Change_Item?.(rowData.row, "Fund", value, text);
                                                            }} ref={CheckFundRef} />


                                                        ) : (
                                                            <text>
                                                                {rowData.Fund}
                                                            </text>
                                                        )}
                                                    </>
                                                }}

                                            </rsuite.Table.Cell>



                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>شماره چک</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.CheckNo} onChange={value => {
                                                                    Change_Item?.(rowData.row, "CheckNo", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.CheckNo}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>بانک </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.Bank} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Bank", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.Bank}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>شعبه </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.Branch} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Branch", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.Branch}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>تاریخ سر رسید </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData, rowIndex) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <DatePicker className="rs-input " isGregorian={false}
                                                                timePicker={false} icon={BiIcon.BiCalendar} value={rowData.CheckDate} onChange={value => {
                                                                    Change_Item?.(rowData.row, "CheckDate", value, "");
                                                                }} />
                                                        ) : (
                                                            <text>
                                                                {rowData.CheckDate}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>وضعیت چک </rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>

                                                                <select className="rs-input" onChange={value => {
                                                                    Change_Item?.(rowData.row, "ConfirmCheck", value.target.value, "")
                                                                }} value={rowData.ConfirmCheck}>
                                                                    <option value="-1">انتخاب نمایید</option>
                                                                    <option value="0">سنتی</option>
                                                                    <option value="1">صیادی (ثبت نشده) </option>
                                                                    <option value="2">صبادی (ثبت شده) </option>

                                                                </select>
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.ConfirmCheck == 0 ?
                                                                    <p>سنتی</p> :
                                                                    rowData.ConfirmCheck == 1 ?
                                                                        <p>صیادی (ثبت نشده)</p> :
                                                                        rowData.ConfirmCheck == 2 ?
                                                                            <p>صیادی (ثبت شده)</p> : <p></p>
                                                                }
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>


                                        <rsuite.Table.Column flexGrow={2} >
                                            <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <rsuite.Input value={rowData.Price} onChange={value => {
                                                                Change_Item?.(rowData.row, "Price", value, "");
                                                            }}

                                                            />
                                                        ) : (
                                                            <text>
                                                                {PN.sliceNumber(rowData.Price)}
                                                                <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column flexGrow={3} >
                                            <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell >
                                                {(rowData) => {
                                                    return <>
                                                        {rowData.status == 'EDIT' ? (
                                                            <>
                                                                <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Comment", value, "");
                                                                }}

                                                                />
                                                            </>

                                                        ) : (
                                                            <text>
                                                                {rowData.Comment}
                                                            </text>
                                                        )}
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>

                                        <rsuite.Table.Column width={100} fixed='right'>
                                            <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                            <rsuite.Table.Cell>
                                                {(rowData) => {
                                                    return <>


                                                        {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                            :
                                                            <BiIcon.BiSave onClick={() => AddItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                        }
                                                        &nbsp;&nbsp;&nbsp;
                                                        <BiIcon.BiTrash onClick={() => Delete(rowData.row)} className='fs-6 text-danger Cursor' />
                                                    </>
                                                }}
                                            </rsuite.Table.Cell>
                                        </rsuite.Table.Column>
                                    </rsuite.Table>
                                    <rsuite.Row>
                                        <rsuite.Col xs={24} className='fw-bold text-start'>
                                            {RecieptList.filter(o => o.PayType == 4 && o.status == "EDIT").length > 0 && RecieptList.filter(o => o.PayType == 4 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(RecieptList.filter(o => o.PayType == 4 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                        </rsuite.Col>
                                    </rsuite.Row>
                                </rsuite.Tabs.Tab>
                            </rsuite.Tabs>





                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1 Font17  pt-5 mt-5 '>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} >
                            <rsuite.Row>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b>مبلغ کل  : </b> <text>  {PN.sliceNumber(HeaderPrice)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(HeaderPrice.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b>مبلغ کل دریافت شده : </b> <text>  {PN.sliceNumber(TotalReciept)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{HeaderPrice != "0" ? <>{PN.convert(TotalReciept.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b> باقیمانده : </b> <text>  {PN.sliceNumber(RemainPrice)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{RemainPrice != "0" ? <>{PN.convert(RemainPrice.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>

                            </rsuite.Row>
                        </rsuite.Col>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className='Font11' >
                            <rsuite.Row>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalPOSReciept == 0 ? "hide" : 'mt-2 '}>
                                    <b>مبلغ کل کارت خوان  : </b> <text>  {PN.sliceNumber(TotalPOSReciept)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalPOSReciept != "0" ? <>{PN.convert(TotalPOSReciept.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalHavaleReciept == 0 ? "hide" : 'mt-2 '}>
                                    <b>مبلغ کل واریز به حساب : </b> <text>  {PN.sliceNumber(TotalHavaleReciept)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalHavaleReciept != "0" ? <>{PN.convert(TotalHavaleReciept.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>

                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalcheckReciept == 0 ? "hide" : 'mt-2 '}>
                                    <b> مبلغ کل چک : </b> <text>  {PN.sliceNumber(TotalcheckReciept)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalcheckReciept != "0" ? <>{PN.convert(TotalcheckReciept.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalFundReciept == 0 ? "hide" : 'mt-2 '}>
                                    <b> مبلغ کل نقد : </b> <text>  {PN.sliceNumber(TotalFundReciept)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalFundReciept != "0" ? <>{PN.convert(TotalFundReciept.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>

                            </rsuite.Row>
                        </rsuite.Col>
                        {hasFactor == 0 ?
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={FinancialBalance * 1 + RemainPrice * 1 < 0 ? 'alert alert-success mt-2' : FinancialBalance * 1 + RemainPrice * 1 > 0 ? 'alert alert-danger mt-2' : "hide"} >
                                <b> باقیمانده حساب مشتری</b>
                                {FinancialBalance * 1 + RemainPrice * 1 < 0 ?
                                    <p> {PN.sliceNumber((FinancialBalance * 1 + RemainPrice * 1) * (-1))} ریال بستانکار
                                        &nbsp;&nbsp;&nbsp;&nbsp; <rsuite.Text className='Font10' as='sub'>{PN.convert(((FinancialBalance * 1 + RemainPrice * 1) * (-1)).toString().replaceAll(',', ''))} ریال</rsuite.Text>
                                    </p>
                                    : FinancialBalance * 1 + RemainPrice * 1 > 0 ?
                                        <p> {PN.sliceNumber(FinancialBalance * 1 + RemainPrice * 1)} ریال بدهکار
                                            &nbsp;&nbsp;&nbsp;&nbsp; <rsuite.Text className='Font10' as='sub'>{PN.convert((FinancialBalance * 1 + RemainPrice * 1).toString().replaceAll(',', ''))} ریال</rsuite.Text>
                                        </p>

                                        :
                                        " 0 ریال"}
                            </rsuite.Col>
                            :
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={FinancialBalance > 0 ? 'alert alert-success mt-2' : FinancialBalance < 0 ? 'alert alert-danger mt-2' : "hide"} >
                                <b> باقیمانده حساب مشتری</b>
                                {FinancialBalance > 0 ?
                                    <p> {PN.sliceNumber(FinancialBalance)} ریال بستانکار
                                        &nbsp;&nbsp;&nbsp;&nbsp; <rsuite.Text className='Font10' as='sub'>{PN.convert(FinancialBalance.toString().replaceAll(',', ''))} ریال</rsuite.Text>
                                    </p>
                                    : FinancialBalance < 0 ?
                                        <p> {PN.sliceNumber(FinancialBalance * (-1))} ریال بدهکار
                                            &nbsp;&nbsp;&nbsp;&nbsp; <rsuite.Text className='Font10' as='sub'>{PN.convert((FinancialBalance * (-1)).toString().replaceAll(',', ''))} ریال</rsuite.Text>
                                        </p>

                                        :
                                        " 0 ریال"}
                            </rsuite.Col>
                        }




                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>

                            <small><b>Enter : </b> اضافه شدن دریافتی جدید <b> | Tab : </b>  جابه جایی در ستون رو به جلو <b>| Shift+Tab :</b> جابه جایی در ستون رو به عقب <b>| Delete :</b> حذف ستون <b>| Enter :</b> اضافه شدن ستون
                                <b>| ESC :</b> بازگشت به صفحه قبل
                                <b>| Shift+p+S :</b> پرینت و ذخیره
                                <b>| Shift+s :</b> ذخیزه
                            </small>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Panel >
            </div >



        </Layout >



    )
}

export default InsertRecieptIndex;